import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import SiteFooter from "./components/SiteFooter";
import Qimen from "./components/qimen/Qimen";
import QimenDetail from "./components/qimen/QimenDetail";

import QimenHistory from "./components/qimen/QimenHistory";

function App_qimen() {
  const [currentView, setCurrentView] = useState("qimen");
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  React.useEffect(() => {
    const token = localStorage.getItem("access_token");
    setIsLoggedIn(!!token);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    setIsLoggedIn(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Navbar
        currentView={currentView}
        setCurrentView={setCurrentView}
        isLoggedIn={isLoggedIn}
        onLogout={handleLogout}
      />
      <main className="flex-grow">
        <Routes>
          <Route path="/index" element={<Qimen />} />     
          <Route path="/QimenDetail" element={<QimenDetail />} /> 
          <Route path="/:id" element={<QimenDetail />} />
          <Route path="/history" element={<QimenHistory />} />   
          <Route path="*" element={<Navigate to="/qimen/index" replace />} />    
        </Routes>
      </main>
     
    </div>
  );
}

export default App_qimen;